import { render, staticRenderFns } from "./portalWeb.vue?vue&type=template&id=d6367206&"
import script from "./portalWeb.vue?vue&type=script&lang=js&"
export * from "./portalWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports